export const notANumberRegex = /[^0-9]/g;

export const normalizeCardNumber = value =>
  value
    .replace(notANumberRegex, '')
    .match(/.{1,4}/g)
    ?.join(' ')
    .substr(0, 19) || '';

export const normalizeExp = (value: string): string =>
  value
    .replace(
      /^([1-9]\/|[2-9])$/g,
      '0$1/' // 3 > 03/
    )
    .replace(
      /^(0[1-9]|1[0-2])$/g,
      '$1/' // 11 > 11/
    )
    .replace(
      /^([0-1])([3-9])$/g,
      '0$1/$2' // 13 > 01/3
    )
    .replace(
      /^(0?[1-9]|1[0-2])([0-9]{2})$/g,
      '$1/$2' // 141 > 01/41
    )
    .replace(
      /^(0?[1-9]|1[0-2])\/?20([0-9]{2})$/g,
      '$1/$2' // 122021 > 12/21
    )
    .replace(/^([1-9])\/([0-9]{2})$/g, '0$1/$2')
    .replace(
      /^([0]+)\/|[0]+$/g,
      '0' // 0/ > 0 and 00 > 0
    )
    .replace(
      /[^\d/]|^[/]*$/g,
      '' // To allow only digits and `/`
    )
    .replace(
      /\/\//g,
      '/' // Prevent entering more than 1 `/`
    );

export const normalizeCSC = value =>
  value.replace(notANumberRegex, '').substr(0, 3) || '';

export const normalizePostalCode = value =>
  value.replace(notANumberRegex, '').substr(0, 5) || '';
